import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        component: () => import('@/views/index'),
        name: 'Index',
        meta: { title: '首页', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/about',
    component: Layout,
    children: [
      {
        path: '/about',
        component: () => import('@/views/aboutUs'),
        name: 'about',
        meta: { title: '关于我们', affix: true }
      }
    ]
  },
  {
    path: '/agreement',
    component: () => import('@/views/policy/agreement.vue'),
    name: 'agreement',
    meta: { title: '用户协议', affix: true }
  },
  {
    path: '/privacy',
    component: () => import('@/views/policy/privacy.vue'),
    name: 'privacy',
    meta: { title: '隐私政策', affix: true }
  },
  {
    path: '/en_US/privacy',
    component: () => import('@/views/policy/privacy_en.vue'),
    name: 'privacy',
    meta: { 
      title: 'Privacy Policy', 
      affix: true,
      lang: 'en'
     }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
